import { render, staticRenderFns } from "./EducationalPeriodChangeActivationType.vue?vue&type=template&id=37c2e211&"
import script from "./EducationalPeriodChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EducationalPeriodChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports